import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery, getUUID} from '@yandex-delivery/utils'

import {fetch} from 'src/shared/api'
import {appConfig} from 'src/shared/config'

import type {AcceptOfferRequest, AcceptOfferResponse} from './model/types'

/**
 * Запрос на принятие оффера
 * @param body Тело запроса
 * @returns Результат запроса
 */
export function fetchAcceptOffer(body: AcceptOfferRequest): Promise<AcceptOfferResponse> {
  return fetch({
    method: 'POST',
    url: addQuery(externalApiURL('dcaa/delivery/v1/offers/accept'), {
      request_id: getUUID(),
      country: appConfig.countryCode,
    }),
    body,
  })
}
